export default __webpack_public_path__ + "static/media/64_mobile.54e06a3c.jpg";